import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import participant from './modules/participant'
import asset from './modules/asset'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    participant,
    asset
  },
})
